import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getClaspTypeDetails, updateClaspType } from "../../helpers/http_clasp_types_requests";
import { useQuery } from "@tanstack/react-query";

export default function ClaspTypeUpdate() {
    const navigate = useNavigate();
    const { id } = useParams();

    const { data, isFetching } = useQuery({ 
        queryKey: ['getClaspTypeDetails', id], 
        queryFn: () => getClaspTypeDetails(id), 
        staleTime: 1000 * 5 
    });

    const { data: claspTypeData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Fecho - Editar",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        updateClaspType(data, () => navigate('/fechos'));
    };

    return <DynamicFormPage 
        isLoading={isFetching} 
        initialData={claspTypeData} 
        title={"Fecho - Editar"} 
        formFieldList={formFieldList} 
        onCancel={() => navigate(-1)} 
        onSubmit={handleSubmit} 
    />;
}
